// FastAPI's error `detail` is a string, or on 422 validation errors a list of
// {type, loc, msg, input, url} objects. Passing those objects to toast.error
// makes React try to render them as children and crash the whole page.
export const apiErrorMessage = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => d?.msg).filter(Boolean).join('; ');
    return msgs || fallback;
  }
  return fallback;
};
